import SEO from '../../components/base/SEO';
import SchemaOrg from '../../components/base/SchemaOrg';
import Navbar from "../../components/feature/Navbar";
import Footer from "../../components/feature/Footer";
import BrandHeroSection from "./components/BrandHeroSection";
import BrandStorySection from "./components/BrandStorySection";
import ProductCategoriesSection from "./components/ProductCategoriesSection";

export default function BrandPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const brandSchema = {
    '@context': 'https://schema.org',
    '@type': 'Brand',
    name: 'Daygreen',
    description: '지속가능한 패션을 만드는 사회적기업 브랜드',
    url: `${siteUrl}/brand`,
    logo: `${siteUrl}/vite.svg`,
  };

  const itemListSchema = {
    '@context': 'https://schema.org',
    '@type': 'ItemList',
    name: 'Daygreen 브랜드 제품',
    description: 'Daygreen의 업사이클링 패션과 기능성 워크웨어',
    itemListElement: [
      {
        '@type': 'ListItem',
        position: 1,
        item: {
          '@type': 'Product',
          name: 're:day',
          description: '업사이클링 패션 브랜드로 폐기물을 새로운 가치로 전환합니다',
          brand: {
            '@type': 'Brand',
            name: 'Daygreen',
          },
        },
      },
      {
        '@type': 'ListItem',
        position: 2,
        item: {
          '@type': 'Product',
          name: '기능성 워크웨어',
          description: '작업자의 안전과 편의를 고려한 기능성 작업복',
          brand: {
            '@type': 'Brand',
            name: 'Daygreen',
          },
        },
      },
    ],
  };

  return (
    <>
      <SEO
        title="브랜드 - Daygreen | re:day 업사이클링 패션 & 기능성 워크웨어"
        description="Daygreen의 브랜드 re:day는 업사이클링 패션으로 환경을 생각하고, 기능성 워크웨어는 작업자의 안전과 편의를 고려합니다. 지속가능한 패션 산업을 만들어갑니다."
        keywords="re:day, 업사이클링 패션, 기능성 워크웨어, 친환경 패션, 지속가능한 브랜드, Daygreen 브랜드, 제로 웨이스트"
        canonical="/brand"
        ogType="website"
      />
      <SchemaOrg schema={[brandSchema, itemListSchema]} />
      <div className="min-h-screen bg-stone-50">
        <Navbar />
        <BrandHeroSection />
        <BrandStorySection />
        <ProductCategoriesSection />
        <Footer />
      </div>
    </>
  );
}